import { render, staticRenderFns } from "./Intro5.vue?vue&type=template&id=94453d34&scoped=true"
import script from "./Intro5.vue?vue&type=script&lang=js"
export * from "./Intro5.vue?vue&type=script&lang=js"
import style0 from "./Intro5.vue?vue&type=style&index=0&id=94453d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94453d34",
  null
  
)

export default component.exports